
const Hourglass = () => {
    return (
        <svg aria-hidden width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="85" height="85" rx="42.5" fill="#BFDFDE" />
            <path
                d="M60 14.5C61.9359 14.5 63.5 16.0673 63.5 18C63.5 19.9327 61.9359 21.5 60 21.5V22.7009C60 27.3406 58.1516 31.7922 54.8703 35.0734L47.4547 42.5L54.8703 49.9266C58.1516 53.2078 60 57.6594 60 62.2969V63.5C61.9359 63.5 63.5 65.0641 63.5 67C63.5 68.9359 61.9359 70.5 60 70.5H25C23.0673 70.5 21.5 68.9359 21.5 67C21.5 65.0641 23.0673 63.5 25 63.5V62.2969C25 57.6594 26.8441 53.2078 30.1253 49.9266L37.5453 42.5L30.1253 35.0734C26.8441 31.7922 25 27.3406 25 22.7009V21.5C23.0673 21.5 21.5 19.9327 21.5 18C21.5 16.0673 23.0673 14.5 25 14.5H60ZM33.6516 28.5H51.25C52.3875 26.7937 53 24.7791 53 22.7009V21.5H32V22.7009C32 24.7791 32.6125 26.7937 33.6516 28.5ZM33.6516 56.5H51.25C50.8672 55.9203 50.4297 55.3734 49.9266 54.8703L42.5 47.4547L35.0734 54.8703C34.5703 55.3734 34.1328 55.9203 33.6516 56.5Z"
                fill="#00807B"
            />
        </svg>
    );
};

export default Hourglass;
